module.exports = __webpack_public_path__ + "static/media/wordpress.be7be3ca.jpg";